<template>
  <div>
    <header-card
      :title="$t('reply.edit')"
      show-back
      :route-url="{name:'owner:reports'}"
    />
    <process-reply :edit="true" />
  </div>
</template>

<script>
import ProcessReply from '@/views/owner-fb/reply/components/ProcessReply'
import HeaderCard from '@/@bya3/components/cards/HeaderCard'

export default {
  name: 'AddReply',
  components: { HeaderCard, ProcessReply },
}
</script>
